<template>
  <v-container fluid class="my-0 py-1">
    <v-row>
      <v-col class="col-3">
        <v-text-field
          placeholder="Buscar usuario..."
          v-model="search"
          hide-details
          append-icon="search"
        ></v-text-field>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary" @click="selected = {}; createUpdate = true">Nuevo usuario</v-btn>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="users" :search="search" :items-per-page="5">
      <template v-slot:item.issuperadmin="{ item }">
        <!-- :disabled="item.id === user.id" -->
        <v-switch
          v-model="item.issuperadmin"
          v-if="item.id !== user.id"
          @change="setUnsetAdmin(item)"
        ></v-switch>
        <v-chip v-if="item.id === user.id" color="success" small>Admin</v-chip>
      </template>
      <template v-slot:item.confirmed="{ item }">
        <v-chip
          small
          :color="item.confirmed ? 'success' : 'warning'"
        >{{ item.confirmed ? 'Sí' : 'No' }}</v-chip>
      </template>
      <template v-slot:item.ultimoacceso="{ item }">{{ ultimoacceso(item) }}</template>
      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom v-if="item.id !== user.id">
          <template v-slot:activator="{ on }">
            <v-btn small text color="primary" v-on="on" @click="lockUnlock(item)">
              <i v-if="item.habilitado" class="fa fa-lock"></i>
              <i v-if="!item.habilitado" class="fa fa-unlock"></i>
            </v-btn>
          </template>
          <span v-if="item.habilitado">Bloquear usuario</span>
          <span v-if="!item.habilitado">Desbloquear usuario</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.id !== user.id">
          <template v-slot:activator="{ on }">
            <v-btn
              small
              text
              color="warning"
              v-on="on"
              @click="selected = item; createUpdate = true"
            >
              <i class="fa fa-pencil"></i>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.id !== user.id">
          <template v-slot:activator="{ on }">
            <v-btn small text color="error" v-on="on" @click="deleteUser(item)">
              <i class="fa fa-trash"></i>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.id !== user.id && !item.issuperadmin">
          <template v-slot:activator="{ on }">
            <v-btn
              small
              text
              color="success"
              v-on="on"
              @click="selected = item; getAssignedProjects(); getProjects(); assignProjectsDlg = true"
            >
              <i class="fa fa-building"></i>
            </v-btn>
          </template>
          <span>Asignar proyectos</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.id !== user.id && !item.issuperadmin && !item.confirmed">
          <template v-slot:activator="{ on }">
            <v-btn small text color="success" v-on="on" @click="selected = item; sendEmailAgain()">
              <i class="fa fa-envelope"></i>
            </v-btn>
          </template>
          <span>Reenviar correo</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="assignProjectsDlg" width="400" persistent>
      <v-card>
        <v-card-title>Asignar proyectos</v-card-title>
        <form @submit.prevent="assignProjects">
          <v-card-text>
            <v-autocomplete
              :items="projects"
              multiple
              label="Proyectos"
              v-model="selectedProjects"
              item-text="name"
              item-value="id"
              outlined
              hide-details
              chips
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-btn color="success" type="submit">Guardar</v-btn>
            <v-btn color="error" @click="assignProjectsDlg = false">Cancelar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <v-dialog width="300" v-model="createUpdate">
      <v-card>
        <v-card-title>{{ selected.id ? 'Editar' : 'Crear' }} usuario</v-card-title>
        <form @submit.prevent="createOrUpdate">
          <v-card-text>
            <v-text-field outlined label="Nombre" v-model="selected.name" required></v-text-field>
            <v-text-field
              outlined
              label="Usuario"
              v-model="selected.usr"
              required
              :disabled="selected.id != null"
            ></v-text-field>
            <v-text-field outlined type="email" label="Correo" v-model="selected.email" required></v-text-field>
            <!-- <v-btn color="success" @click="activate2FA">Activar 2FA</v-btn> -->
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn type="submit" color="success">Guardar {{ selected.id ? 'Cambios' : '' }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <Confirmacion :model="confModel" @result="isConfirmed" />

  </v-container>
</template>

<script>
import Vue from "vue";
import { API } from "../../../globals";
import { Auth } from "../../../classes/Auth";
import Confirmacion from "@/components/smartchronos/Confirm.vue";
import moment from "moment";

import { apiv1 } from "../../../libs/apiv1";

const auth = new Auth();

export default Vue.extend({
  name: "Usuarios",
  components: {
    Confirmacion
  },
  data: () => ({
    headers: [
      { text: "Nombre", value: "name" },
      { text: "Usuario", value: "usr" },
      { text: "Correo", value: "email" },
      { text: "Confirmada", value: "confirmed", align: "center" },
      { text: "Administrador", value: "issuperadmin" },
      { text: "Último acceso", value: "ultimoacceso" },
      {
        text: "Acciones",
        value: "acciones",
        sortable: false,
        align: "center"
      }
    ],
    createUpdate: false,
    search: null,
    selected: {},
    users: [],
    user: auth.getUser(),
    assignProjectsDlg: false,
    selectedProjects: [],
    projects: [],
    confModel: false,
    confirmed: false,
    action: null
  }),
  mounted() {
    this.getUsers();
    this.getProjects();
  },
  methods: {
    getProjects: function() {
      apiv1({
        method: "GET",
        url: `projects`
      }).then(res => (this.projects = res.data));
    },
    getUsers: function() {
      apiv1({
        method: "GET",
        url: `admin/users`
      }).then(res => {
        this.users = res.data;
      });
    },
    createOrUpdate: function() {
      let url = `admin/users`;
      let method = "POST";
      if (this.selected.id) {
        url = `admin/user/${this.selected.id}`;
        method = "PUT";
      }

      apiv1({
        method: method,
        url: url,
        data: this.selected
      })
        .then(res => {
          this.getUsers();
          this.selected = {};
          this.createUpdate = false;
          this.$awn.success(res.data);
        })
        .catch(err => this.$awn.alert(err.response.data));
    },
    deleteUser: function(item) {
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea eliminar el usuario '${item.usr.toUpperCase()}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo eliminarlo",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$awn.async(
            apiv1({
              method: "DELETE",
              url: `admin/user/${item.id}`
            }).then(res => {
              this.getUsers();
              this.$awn.success(res.data);
            })
          );
        }
      });
    },
    lockUnlock: function(item) {
      apiv1({
        method: "PUT",
        url: `admin/user/lock-unlock/${item.id}`
      }).then(res => {
        this.getUsers();
        this.$awn.success(res.data);
      });
    },
    setUnsetAdmin: function(item) {
      apiv1({
        method: "PUT",
        url: `admin/user/admin/${item.id}`
      }).then(res => {
        this.getUsers();
        this.$awn.success(res.data);
      });
    },
    assignProjects: function() {
      apiv1({
        method: "PUT",
        url: `admin/user/assign-projects/${this.selected.id}`,
        data: { proyectos: this.selectedProjects }
      }).then(res => {
        this.assignProjectsDlg = false;
        this.selected = {};
        this.$awn.success(res.data);
      });
    },
    getAssignedProjects: function() {
      apiv1({
        method: "GET",
        url: `admin/user/assigned-projects/${this.selected.id}`
      }).then(res => {
        this.selectedProjects = res.data.map(function(item) {
          return item.proyecto;
        });
      });
    },
    sendEmailAgain: function() {
      apiv1({
        method: "PUT",
        url: `admin/user/resend-confirmation-email/${this.selected.id}`,
        data: {}
      })
        .then(res => {
          this.$awn.success(res.data);
        })
        .catch(err => this.$awn.alert(err.response.data));
    },
    isConfirmed(val) {
      this.confirmed = val;
      this.confModel = false;
    },
    ultimoacceso(user) {
      const usr = this.users.find(x => x === user);
      // console.log(usr);
      if (usr) {
        if (usr.sesiones.length > 0) {
          const last_sesion = usr.sesiones[usr.sesiones.length - 1];
          return moment(last_sesion.fecha).format("YYYY-MM-DD HH:mm:ss");
        }
      }
      return "Nunca";
    }
  }
});
</script>

<style>
</style>